<!--px-lg-5-->
<div class="p-0 my-4 mx-auto">
  <h4 *ngFor="let annexe of sanitizedAnnexes" class="{{class}}">
    <span class="d-block" [innerHtml]="annexe"></span>
  </h4>
</div>
